module.exports = __webpack_public_path__ + "static/media/whatsapp.c45df616.svg";